import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ToolkitStore } from '@reduxjs/toolkit/dist/configureStore';
import { AppStore, Goods, RecordList } from '../types';
import { apiGetGoodsList } from '../api';
interface RequestParams {
  cat: string;
}

// 请求成功时传送的参数
interface SuccessParams extends RequestParams {
  list: Array<Goods>;
}
// 请求失败时传送的参数
interface FailureParams extends RequestParams {
  error: string;
}

type GoodsListType = {
  [cat: string]: RecordList<Goods>;
};
const goodsListSlice = createSlice({
  name: 'goodsList',
  initialState: {} as GoodsListType,
  reducers: {
    goodsListRequest: (state: GoodsListType, action: PayloadAction<RequestParams>) => {
      if (!state[action.payload.cat]) {
        state[action.payload.cat] = { fetching: true, loaded: false } as RecordList<Goods>;
      }
      state[action.payload.cat].fetching = true;
      return state;
    },
    goodsListSuccess: (state: GoodsListType, action: PayloadAction<SuccessParams>) => {
      if (!state[action.payload.cat]) {
        state[action.payload.cat] = { fetching: true, loaded: false } as RecordList<Goods>;
      }
      state[action.payload.cat].fetching = false;
      state[action.payload.cat].loaded = true;
      state[action.payload.cat].results = action.payload.list;
      return state;
    },
    goodsListFailure: (state: GoodsListType, action: PayloadAction<FailureParams>) => {
      if (!state[action.payload.cat]) {
        state[action.payload.cat] = { fetching: true, loaded: false } as RecordList<Goods>;
      }
      state[action.payload.cat].fetching = false;
      state[action.payload.cat].loaded = true;
      state[action.payload.cat].error = action.payload.error;
      return state;
    },
    goodsListClear: (state: GoodsListType) => {
      state = {};
      return state;
    },
  },
});

export const { goodsListRequest, goodsListSuccess, goodsListFailure, goodsListClear } = goodsListSlice.actions;
export default goodsListSlice.reducer;

export const goodsListEffect = {
  'goodsList/clear': (store: ToolkitStore<AppStore>) => store.dispatch(goodsListClear()),
  'goodsList/goodsListRequest': async (store: ToolkitStore<AppStore>, action: PayloadAction<RequestParams>) => {
    var list = store.getState().goodsList[action.payload.cat];
    if (!action.payload.cat) {
      store.dispatch(goodsListSuccess({ list: [], cat: action.payload.cat ?? '' }));
    }
    if (list?.loaded === true && !list?.error) {
      store.dispatch(goodsListSuccess({ list: list.results ?? [], cat: action.payload.cat }));
    } else {
      try {
        let res = await apiGetGoodsList(action.payload.cat);
        let data = res.data;
        if (data.code === 200) {
          store.dispatch(goodsListSuccess({ list: data.data, cat: action.payload.cat }));
        } else {
          store.dispatch(goodsListFailure({ error: data.msg || '获取失败', cat: action.payload.cat }));
        }
      } catch (e: any) {
        store.dispatch(goodsListFailure({ error: e.toString() || '获取失败', cat: action.payload.cat }));
      }
    }
  },
};
